/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { GiftIcon, WarningIcon } from '@phosphor-icons/react';
import { Flex, Input } from 'antd';
import React, { useEffect } from 'react';
import { Controller, FormProvider, UseFormReturn } from 'react-hook-form';
import {
  Button,
  Typography
} from 'tfc-components';

import { IForm } from '.';

import { ServicePackageData } from 'services/servicePackages/type';

interface Props {
  total: number;
  duration: 'monthly' | 'yearly';
  billingType: 'one-time' | 'subscription';
  readonly?: boolean;
  visiblePackages: ServicePackageData[] | null;
  width?: string;
  mainPackageSelected: ServicePackageData | null;
  method: UseFormReturn<IForm>
  dataDiscount?: {
    discountAmount: number,
    discountDay: number
  };
  isConfirm?: boolean
}

const ChoosePackage: React.FC<Props> = ({
  billingType,
  total,
  readonly,
  visiblePackages,
  width,
  mainPackageSelected,
  method,
  dataDiscount,
  isConfirm,
  duration
}) => {
  const isEmpty = false;

  useEffect(() => {
    if (billingType === 'one-time' && duration === 'monthly') {
      visiblePackages?.forEach((item, idx) => {
        const currentQty = method.getValues(`addOnPackage.${idx}.quantity`);
        if (item?.quantity && item.quantity < 3 && currentQty !== 3) {
          method.setValue(`addOnPackage.${idx}.quantity`, 3, {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
      });

      if (mainPackageSelected) {
        const mainCurrent = method.getValues('mainPackage.quantity');
        if (mainPackageSelected.duration < 3 && mainCurrent !== 3) {
          method.setValue('mainPackage.quantity', 3, {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
      }
    }
  }, [billingType, duration, visiblePackages, method,
    mainPackageSelected?.duration, mainPackageSelected?.id]);
  return (
    <div className="p-checkout_productWrap">
      {!isConfirm && (
        <div className="p-changePlan_warning">
          <WarningIcon size={20} />
          <Typography.Text fontweight="600">
            Changing to a new plan may require data deletion if limits are lower.
          </Typography.Text>
        </div>
      )}

      <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct fs-20x24">Product list</Typography.Text>
      <div className="p-checkout_table">
        <div className={isConfirm ? 'p-changePlan_tableHead' : 'p-checkout_table_head'}>
          <div>
            <Typography.Text fontweight="600">Name</Typography.Text>
          </div>
          <div>
            <Typography.Text fontweight="600">Unit</Typography.Text>
          </div>
          <div>
            <Typography.Text fontweight="600">Duration ({duration === 'monthly' ? 'month' : 'year'})</Typography.Text>
          </div>
          <div>
            <Typography.Text fontweight="600">Base price (VND)</Typography.Text>
          </div>
          <div>
            <Typography.Text fontweight="600">Total price (VND)</Typography.Text>
          </div>
        </div>
        <FormProvider {...method}>
          {mainPackageSelected && (
            <div className={isConfirm ? 'p-changePlan_tableHead' : 'p-checkout_table_row'}>
              <div>{mainPackageSelected?.name}</div>
              <div className="p-checkout_table_quantity">
                <Typography.Text extendClasses="p-checkout_table_inputText">
                  {mainPackageSelected?.unit || 1}
                </Typography.Text>
              </div>
              <div>
                <Controller
                  name="mainPackage.quantity"
                  render={({ field }) => {
                    if (readonly) {
                      return (
                        <div>
                          {
                            billingType === 'subscription' ? (
                              <Typography.Text>
                                {duration === 'monthly' ? 'Month' : 'Year'}
                              </Typography.Text>
                            ) : (
                              <Typography.Text extendClasses="p-checkout_table_inputText">
                                {isEmpty ? '--' : field.value}
                              </Typography.Text>
                            )
                          }
                        </div>

                      );
                    }

                    return (
                      <div>
                        {
                          billingType === 'subscription' ? (
                            <Typography.Text>
                              {duration === 'monthly' ? 'Month' : 'Year'}
                            </Typography.Text>
                          ) : (
                            <div className="p-checkout_table_quantity">
                              <Button
                                disabled={billingType === 'one-time' && duration === 'monthly' ? field.value <= 3 : field.value <= 1}
                                extendClasses="p-checkout_table_button"
                                onClick={() => field.value > 1 && field.onChange(field.value - 1)}
                              >
                                <MinusOutlined />
                              </Button>
                              <Input
                                className="p-checkout_table_input"
                                style={{ width: '70px', textAlign: 'center' }}
                                {...field}
                                // onChange={(e) => field.onChange(parseInt(e.target.value, 10))}
                                onChange={(e) => {
                                  if (parseInt(e.target.value, 10) < 3 && duration === 'monthly') {
                                    field.onChange(3);
                                  } else {
                                    field.onChange(parseInt(e.target.value, 10));
                                  }
                                }}
                                type="number"
                              />
                              <Button
                                extendClasses="p-checkout_table_button"
                                onClick={() => field.onChange(field.value + 1)}
                              >
                                <PlusOutlined />
                              </Button>
                            </div>
                          )
                        }
                      </div>
                    );
                  }}
                />
              </div>
              <div>{isEmpty ? '--' : mainPackageSelected?.price.toLocaleString('vi')}</div>
              <div style={{ width }} className="p-checkout_table_totalValue">
                {isEmpty ? '--' : ((mainPackageSelected?.price || 1) * (mainPackageSelected?.unit || 1) * (billingType === 'one-time' ? mainPackageSelected?.quantity || 1 : 1)).toLocaleString('vi')}
              </div>
            </div>
          )}
          {
            dataDiscount && (dataDiscount?.discountAmount || dataDiscount?.discountDay) && dataDiscount?.discountAmount > 0 && billingType === 'one-time'
            && (
              <div className={isConfirm ? 'p-changePlan_tableHead' : 'p-checkout_table_row'}>
                <Flex style={{ paddingLeft: 20 }} gap={4} align="center">
                  <Typography.Text extendClasses="">
                    Discount
                  </Typography.Text>

                </Flex>

                <div />
                <div />
                <div />
                <Typography.Text extendClasses="p-checkout_table_totalValue" style={{ width }}>{`- ${dataDiscount?.discountAmount.toLocaleString('vi')}`}</Typography.Text>
              </div>
            )
          }
          {visiblePackages?.map((key, index) => {
            const { id, name } = key;
            const unitPrice = key?.price ?? 0;
            const totalPrice = (key?.unit || 1) * (billingType === 'one-time' ? key?.quantity || 1 : 1) * unitPrice;
            return (
              <div className={isConfirm ? 'p-changePlan_tableHead' : 'p-checkout_table_row'} key={id}>
                <div>{name === '' ? '--' : name}</div>
                <div className="p-checkout_table_quantity">
                  <Controller
                    name={`addOnPackage[${index}].unit`}
                    render={({ field }) => {
                      if (readonly) {
                        return (
                          <Typography.Text extendClasses="p-checkout_table_inputText">
                            {isEmpty ? '--' : field.value}
                          </Typography.Text>
                        );
                      }

                      return (
                        <>
                          <Button
                            disabled={field.value === 1}
                            extendClasses="p-checkout_table_button"
                            onClick={() => field.value > 1 && field.onChange(field.value - 1)}
                          >
                            <MinusOutlined />
                          </Button>
                          <Input
                            className="p-checkout_table_input"
                            style={{ width: '70px', textAlign: 'center' }}
                            {...field}
                            onChange={(e) => field.onChange(parseInt(e.target.value, 10))}
                            type="number"
                          />
                          <Button
                            extendClasses="p-checkout_table_button"
                            onClick={() => field.onChange(field.value + 1)}
                          >
                            <PlusOutlined />
                          </Button>
                        </>
                      );
                    }}
                  />
                </div>

                <div>
                  <Controller
                    name={`addOnPackage.${index}.quantity`}
                    render={({ field }) => {
                      if (readonly) {
                        return (
                          <div>
                            {billingType === 'subscription' ? (
                              <Typography.Text>
                                {duration === 'monthly' ? 'Month' : 'Year'}
                              </Typography.Text>
                            )
                              : (
                                <Typography.Text extendClasses="p-checkout_table_inputText">
                                  {isEmpty ? '--' : field.value}
                                </Typography.Text>
                              )}
                          </div>

                        );
                      }
                      return (
                        <div>
                          {
                            billingType === 'subscription' ? (
                              <Typography.Text>
                                {duration === 'monthly' ? 'Month' : 'Year'}
                              </Typography.Text>
                            ) : (
                              <div className="p-checkout_table_quantity">
                                <Button
                                  disabled={billingType === 'one-time' && duration === 'monthly' ? field.value <= 3 : field.value <= 1}
                                  extendClasses="p-checkout_table_button"
                                  onClick={() => field.value > 1 && field.onChange(field.value - 1)}
                                >
                                  <MinusOutlined />
                                </Button>
                                <Input
                                  className="p-checkout_table_input"
                                  style={{ width: '70px', textAlign: 'center' }}
                                  {...field}
                                  onChange={(e) => {
                                    if (parseInt(e.target.value, 10) < 3 && duration === 'monthly') {
                                      field.onChange(3);
                                    } else {
                                      field.onChange(parseInt(e.target.value, 10));
                                    }
                                  }}
                                  type="number"
                                />
                                <Button
                                  extendClasses="p-checkout_table_button"
                                  onClick={() => field.onChange(field.value + 1)}
                                >
                                  <PlusOutlined />
                                </Button>
                              </div>
                            )
                          }
                        </div>
                      );
                    }}
                  />
                </div>
                <div>{isEmpty ? '--' : unitPrice.toLocaleString('vi')}</div>
                <div style={{ width }} className="p-checkout_table_totalValue">{isEmpty ? '--' : totalPrice.toLocaleString('vi')}</div>
              </div>
            );
          })}

        </FormProvider>

        <div className={`p-checkout_table_total ${isConfirm ? 'p-changePlan_tableHead' : 'p-checkout_table_row'}`}>
          <Typography.Text fontweight="600" extendClasses="p-checkout_table_totalLabel">Total</Typography.Text>
          <div />
          <div />
          <div />
          <Typography.Text fontweight="600" extendClasses="p-checkout_table_totalValue" style={{ width }}>
            {isEmpty ? '--' : total < 0 ? 0 : total.toLocaleString('vi')}
          </Typography.Text>
        </div>
      </div>

      {
        dataDiscount && billingType === 'subscription'
        && (
          <div className="p-paymentMethod_gift">
            <Flex align="center" gap={8}>
              <div className="p-paymentMethod_gift_iconWrap">
                <GiftIcon size={20} />
              </div>
              <Typography.Text extendClasses="p-paymentMethod_gift_title">Extra Days</Typography.Text>
            </Flex>

            <Typography.Text extendClasses="p-paymentMethod_gift_description">
              Discount is converted into extra days, extending your plan duration.
            </Typography.Text>
          </div>
        )
      }

    </div>
  );
};

export default ChoosePackage;
